// extracted by mini-css-extract-plugin
module.exports = {"root":"ComptabiliteExports_root__2xGlA"};